import styled from "styled-components";

export const Card = styled.div`
  background: #00467E;
  overflow: visible;
`;

export const CardHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1rem 1.5rem;

  @media (max-width: 768px) {
    gap: 0.5rem;
    padding: 0.75rem;
  }
`;

export const VideoIcon = styled.div`
  width: 48px;
  height: 48px;
  background-color: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;

  .video-icon {
    height: 30px;
    width: 30px;
    filter: invert(1);
  }

  @media (max-width: 768px) {
    width: 40px;
    height: 40px;
    font-size: 1.25rem;
  }
`;

export const UserInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  padding-left: 10px;

  @media (max-width: 768px) {
    padding-left: 0.5rem;
    gap: 0.25rem;
    flex: 1;
  }
`;

export const UserName = styled.span`
  color: white;
  font-size: 1rem;
  font-weight: 500;

  .user-icon {
    height: 25px;
    width: 25px;
    filter: invert(1);
    padding-right: 5px;
  }

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
`;

export const RequestDate = styled.span`
  color: white;
  font-size: 0.875rem;

  .clock-icon{
    height: 25px;
    width: 25px;
    filter: invert(1);
    padding-right: 5px;
  }

  @media (max-width: 768px) {
    font-size: 0.8rem;
  }
`;

export const CategoryTag = styled.span`
  color: white;
  font-size: 0.875rem;
  flex: 1;
  text-align: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const StatusWrapper = styled.div`
  display: flex;
  align-items: center;

  @media (max-width: 768px) {
    display: none;
  }
`;

interface StatusBadgeProps {
  status?: "pendente" | "respondida";
}

export const StatusBadge = styled.button<StatusBadgeProps>`
  padding: 0.7rem;
  min-width: 140px;
  text-align: center;
  background-color: ${(props) => props.status === "respondida" ? "white" : "transparent"};
  color: ${(props) => props.status === "respondida" ? "#1D2C3B" : "white"};
  border: 1px solid white;
  border-radius: 2px;
  font-size: 0.875rem;
  font-family: "Poppins", sans-serif;
  font-weight: 600;
  cursor: default;
  pointer-events: none;

  img{
    height: 12px;
    width: 12px;
    filter: invert(1);
    margin-right: 5px;
  }

  .clock-icon {
    height: 12px;
    width: 12px;
    filter: invert(1);
  }
`;

export const ReplyButton = styled.button`
  align-items: center;
  padding: 0.8rem 1rem;
  background-color: white;
  color: #313144;
  border: none;
  border-radius: 2px;
  font-size: 0.8125rem;
  font-weight: 600;

  &:hover {
    background-color: #e8e8e8;
  }

  @media (max-width: 768px) {
    padding: 0.7rem 0.8rem;
    font-size: 0.75rem;
  }
`;

export const ExpandButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0.25rem;

  &:hover {
    opacity: 0.8;
  }
`;

export const VideoContainer = styled.div`
  padding: 1.5rem;
  background: #00467E;
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  @media (max-width: 768px) {
    padding: 1rem;
  }

  .answerListHeader {
    margin-top: 2rem;
    color: white;
    font-weight: bold;
    font-size: 1.3rem;
    text-decoration: underline;
  }
    
  .answer {
    margin: 1rem;
    border-left: 1px solid #999;
    padding: 0 1rem;
  }
`;

export const Description = styled.p`
  color: white;
  font-size: 0.9375rem;
  line-height: 1.6;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    font-size: 0.875rem;
    line-height: 1.5;
  }
`;

export const VideoPlayerWrapper = styled.div`
  background-color: #000;
  border-radius: 2px;
  overflow: hidden;

  .video-error {
    color: #ff6b6b;
    text-align: center;
    padding: 2rem;
    background: #1a1a1a;
  }
`;

export const Video = styled.video`
  width: 100%;
  height: auto;
  max-height: 400px;
  display: block;
  background-color: #666;
`;

export const VideoControls = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1rem;
  background-color: rgba(0, 0, 0, 0.8);

  @media (max-width: 768px) {
    gap: 0.5rem;
    padding: 0.5rem 0.75rem;
  }
`;

export const ControlButton = styled.button`
  background: none;
  border: none;
  color: white;
  font-size: 1.5rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0.25rem;
  border-radius: 50%;

  &:hover {
    background-color: rgba(255, 255, 255, 0.2);
  }
`;

export const TimeInfo = styled.span`
  color: white;
  font-size: 0.875rem;
  font-family: monospace;
  min-width: 45px;

  @media (max-width: 768px) {
    font-size: 0.75rem;
    min-width: 40px;
  }
`;

export const ProgressBarContainer = styled.div`
  flex: 1;
`;

export const ProgressBar = styled.input`
  width: 100%;
  height: 4px;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 2px;
  outline: none;
  cursor: pointer;

  &::-webkit-slider-thumb {
    appearance: none;
    width: 12px;
    height: 12px;
    background: white;
    border-radius: 50%;
    cursor: pointer;
  }

  &::-moz-range-thumb {
    width: 12px;
    height: 12px;
    background: white;
    border-radius: 50%;
    border: none;
    cursor: pointer;
  }
`;
